export var EExportTemplateType;
(function (EExportTemplateType) {
    EExportTemplateType[EExportTemplateType["PurSorting"] = 3] = "PurSorting";
    EExportTemplateType[EExportTemplateType["Bill"] = 8] = "Bill";
})(EExportTemplateType || (EExportTemplateType = {}));
